/** Validate the amount as a number to 2 fixed decimal places */
export function validateAmount(amount) {
    if (Number.isNaN(parseFloat(String(amount))) || String(amount).length === 0) {
        return 'amount error';
    }
    var amt = typeof amount === 'string' ? Number(amount) : amount.toFixed(2);
    if (Number(amt) < 0) {
        return "-$".concat(Math.abs(Number(amt)).toFixed(2));
    }
    return "$".concat(Number(amt).toFixed(2));
}
/** Determine if a value is not a positive number (can be negative, null, undefined, or empty string) */
export function isNotPositiveNumber(amount) {
    return typeof amount !== 'number' && Number.isNaN(parseFloat(amount))
        ? true
        : Number(amount) < 0;
}
/** Conditionally add one or more class names based on a boolean value */
export function addClassNames(className, addedClasses, styleConditional) {
    return styleConditional
        ? "".concat(className, " ").concat(addedClasses.join(' '))
        : className;
}
//# sourceMappingURL=amount-utils.js.map